import React, { Component } from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import UppercaseHeader from '../UppercaseHeader';

import 'css/components/jobs/_JobSection.scss';

const FindLinksRegex = /\[[^\]]+\]\([^\)]+\)/g;
const LinkValuesRegex = /^\[([^\]]+)\]\(([^\)]+)\)$/;
const LastSpaceRegex = /\s(?=[^\s]+$)/;

export default class JobSection extends Component {
  static propTypes = {
    section: PropTypes.object,
  };

  render() {
    const { section } = this.props;
    const sectionItems = section.details.split('\n').map((sectionItem, i) => {
      sectionItem = sectionItem.replace(LastSpaceRegex, '\u00a0');
      const nonLinks = sectionItem.split(FindLinksRegex);
      const links = sectionItem.match(FindLinksRegex);
      const itemParts = [];
      nonLinks.forEach((nonLink, j) => {
        itemParts.push(
          <div className="sectionItemPart" key={'nonlink_' + j}>
            {nonLink}
          </div>,
        );
        if (links && j < links.length) {
          const matches = LinkValuesRegex.exec(links[j]);
          itemParts.push(
            <a href={matches[2]} key={'link_' + j}>
              {matches[1]}
            </a>,
          );
        }
      });
      return (
        <div
          className={classnames({
            listItem: sectionItem.startsWith('- ') || sectionItem.startsWith('– '),
            sectionItem: true,
          })}
          key={i}>
          {itemParts}
        </div>
      );
    });
    return (
      <div className="jobSection">
        <UppercaseHeader>{section.name}</UppercaseHeader>
        <div className="sectionItems">{sectionItems}</div>
      </div>
    );
  }
}
